export const SET_ANALYTICS_DATA = "SET_ANALYTICS_DATA";